import React from 'react';
import { reduxForm } from 'redux-form';
import { Panel, Col, Button } from 'react-bootstrap';
import FeedMapping from '../FeedMapping';

const WizardFormStep3 = props => {
  const { handleSubmit, prevPage, includesVideo } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Panel className="panel-mapping">
        <Col xs={12}>
          <h2>Mapping</h2>
        </Col>
        <Panel.Body>
          <FeedMapping includesVideo={includesVideo} />
        </Panel.Body>
        <Panel.Footer>
          <Button bsStyle='info' onClick={prevPage} className='wizard-button'>
            Previous
          </Button>
          <Button type='submit' bsStyle='success' className='wizard-button'>
            Next
          </Button>
        </Panel.Footer>
      </Panel>
    </form>
  );
};

export default reduxForm({
  form: 'AdminNewFeedCampaignForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(WizardFormStep3);
